/**
 * Filter tracking utilities for RBC flights
 * Fires applied_filter event when filters are applied
 */

import { trackEvent } from "@hopper-b2b/api";

export enum FilterType {
  PRICE = "price",
  STOPS = "stops",
  AIRLINE = "airline",
  TIME = "time",
  AIRPORT = "airport",
  FLIGHT_NUMBER = "flight number",
  FARECLASS = "fareclass",
}

export interface AppliedFilterProperties {
  filter_type: FilterType;
}

/**
 * Track when a filter is applied
 */
export const trackAppliedFilter = (filterType: FilterType) => {
  trackEvent({
    eventName: "applied_filter",
    properties: {
      filter_type: filterType,
    },
  });
};
